import { render, staticRenderFns } from "./BuyingOfferItem.vue?vue&type=template&id=03c78394&scoped=true&"
import script from "./BuyingOfferItem.vue?vue&type=script&lang=js&"
export * from "./BuyingOfferItem.vue?vue&type=script&lang=js&"
import style0 from "./BuyingOfferItem.vue?vue&type=style&index=0&id=03c78394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c78394",
  null
  
)

export default component.exports